export const AI_PAGE_BUILDER_ROUTE_KEYS = {
  generate_template: "AI-sales-page-builder-select-template",
  select_template: "AI-sales-page-builder-update-template",
  editor: "AI-sales-page-builder-editor",
};

export const AI_PAGE_BUILDER_ROUTE_IDS = {
  [AI_PAGE_BUILDER_ROUTE_KEYS.generate_template]:
    "/ai-sales-page-builder/:ai_conversation_uid/generate-template",
  [AI_PAGE_BUILDER_ROUTE_KEYS.select_template]:
    "/ai-sales-page-builder/:ai_conversation_uid/select-template",
  [AI_PAGE_BUILDER_ROUTE_KEYS.editor]: "/ai-sales-page-builder/editor",
};

export const AI_PAGE_BUILDER_ROUTE_GENERATORS = {
  [AI_PAGE_BUILDER_ROUTE_KEYS.generate_template]: ({ ai_conversation_uid }) =>
    `/ai-sales-page-builder/${ai_conversation_uid}/generate-template`,
  [AI_PAGE_BUILDER_ROUTE_KEYS.select_template]: ({ ai_conversation_uid }) =>
    `/ai-sales-page-builder/${ai_conversation_uid}/select-template`,
  [AI_PAGE_BUILDER_ROUTE_KEYS.editor]: ({ conversationUid }) =>
    `/ai-sales-page-builder/editor?conversationUid=${conversationUid}`,
};

/**
 * actions that the caqn be triggered from the page builder
 */
export const ai_page_builder_action_keys = {
  go_to_editor: "go-to-editor",
  edit_in_builder: "edit_in_builder",
  published_page: "published_page",
  updated_conversation: "updated_conversation",
  update_failed: "update_failed",
  restored_conversation: "restored_conversation",
  refresh_page: "refresh_page",
};
